import React from "react";
import { Shirt, Scissors, CircleDot, Palette } from "lucide-react";
import Reveal from "@/components/Reveal";

const FEATURES = [
    {
        icon: Shirt,
        title: "১০০% রং গ্যারান্টি",
        text: "ছবির মতোই রং, ধোয়ার পরেও ফেড হবে না।",
    },
    {
        icon: Scissors,
        title: "সাইজ রিটার্ন পলিসি",
        text: "ডেলিভারি ম্যান এর সামনেই প্রোডাক্ট চেক করে নেয়ার সুবিধা।",
    },
];

export default function ProductHighlights() {
    return (
        <section id="highlights" className="bg-[#FBF9F5] pt-12 md:pt-20 pb-0 scroll-mt-[4.25rem]">
            <div className="max-w-6xl mx-auto px-4 sm:px-6">
                {/* ─── Header ─── */}
                <Reveal className="text-center max-w-2xl mx-auto mb-8 md:mb-12">
                    <p className="text-sm font-semibold text-[#A84320] tracking-wide mb-2">কেন এই পাঞ্জাবি</p>
                    <h2 className="font-serif text-xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#1E1B18]">
                        কুমিল্লার অরিজিনাল প্রিমিয়াম খাদি পাঞ্জাবি – গরমের সেরা আরাম
                    </h2>
                </Reveal>

                {/* ─── Feature Benefits Grid (2x2) ─── */}
                <div className="grid grid-cols-2 gap-3 md:gap-5">
                    {FEATURES.map(({ icon: Icon, title, text }, i) => (
                        <Reveal key={title} delay={i * 0.06}>
                            <div className="h-full rounded-2xl bg-white border border-[#E4DDD3] p-3 md:p-6 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300">
                                <span className="inline-flex items-center justify-center w-8 h-8 md:w-10 md:h-10 rounded-xl bg-[#FBEBE3] text-[#A84320] mb-2 md:mb-3">
                                                                    <Icon size={16} className="md:hidden" />
                                                                    <Icon size={19} className="hidden md:block" />
                                </span>
                                <h3 className="text-[13px] md:text-base font-semibold text-[#1E1B18] leading-snug">{title}</h3>
                                <p className="mt-1 md:mt-1.5 text-[11px] md:text-sm text-[#5C554D] leading-relaxed">{text}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}